// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-video-dialog-content {
    position: relative;
    overflow: hidden;
    background-color: #000;
    padding: 0;
}

.image-video-close-button {
    position: absolute;
    top: 21px;
    right: 23px;
    color: white;
    z-index: 1;
}

.image-video-close-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.image-video-iframe {
    width: 100%;
    height: 100%;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/ImageVideo.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".image-video-dialog-content {\n    position: relative;\n    overflow: hidden;\n    background-color: #000;\n    padding: 0;\n}\n\n.image-video-close-button {\n    position: absolute;\n    top: 21px;\n    right: 23px;\n    color: white;\n    z-index: 1;\n}\n\n.image-video-close-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.image-video-iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
